export default [
    '#ffffff',
    '#6DCFF6',
    '#00C6C2',
    '#448CCB',
    '#39B54A',
    '#c7ff93',
    '#daad99',
    '#FF0000',
    '#EC008C',
    '#7841CC',
    '#e7ce39',
    '#ff940a',
]



